/*
 * Centralized error handling.
 */


/**
 * Main class for error handling.
 *
 * @class      ErrorHandler
 */
export class ErrorHandler
{
	/**
	 * Handles generic errors thrown by the class.
	 *
	 * @param      {string}  className     The name of the class where the error
	 *                                     occured
	 * @param      {string}  functionName  The function name where the error
	 *                                     occured
	 * @param      {string}  errorMessage  The error message the error generated
	 */
	static error( className = '[ No class specified ]', functionName = '[ No function specified ]', errorMessage = '[ No error specified ]' )
	{
		// We have the console object, right?
		if ( typeof console !== 'undefined' )
		{
			// Can we error? Cuz, you know, fuck IE...
			if ( typeof console.error === 'function' )
			{
				console.error( className + '.' + functionName + ': ' + errorMessage );
			}
			// Can we log at all? Cuz you know, fuck REALLY old IE especially...
			else if ( typeof console.log === 'function' )
			{
				console.log( className + '.' + functionName + ': ' + errorMessage );
			}
		}
	}
}



// WEBPACK FOOTER //
// ../wp-content/themes/wisesite/assets/js/errorhandler/errorhandler.js